import React from 'react'
import Config from 'config'
import { connect } from 'react-redux'
import bowser from 'bowser'
import {
  playRequest,
  setSkipFeature,
  openSettingsScreen,
  setQuickSpin
} from 'macguffin/redux/actions'
import { runAutoPlay, updateAutoplayBalance } from 'macguffin/components/autoplay/actions'
import { RUN_AUTOPLAY } from 'macguffin/components/autoplay/constants'
import { PLAY, SET_QUICKSPIN, SETTINGSCREENS } from 'macguffin/redux/constants'
import { uiButtonPressed, setPopupScreen, setAutoPlayReStart } from '../redux/actions'
import Autoplay from './controls/autoplay/ui'
import SettingsButton from './controls/SettingsButton'
import SimpleArea from './controls/SimpleArea'
import InfoArea from './controls/InfoArea'
import BetArea from './controls/BetArea'
import SpinButton from './controls/SpinButton'
import QuickspinButton from './controls/QuickspinButton'
import QuickBetButton from './controls/QuickBetButton'
import { POPUP_SCREENS, BUTTON_CLOSE } from '../redux/constants'
import { getBet, stopPropagation } from '../utils'

const preventZoomOnIOS = () => {
  if (bowser.ios && bowser.safari) {
    const gameControls = document.getElementById('gameControls')
    gameControls && gameControls.addEventListener('touchmove', e => {
      e.preventDefault()
    }, { capture: true, passive: false })
  }
}

@connect(
  state => ({
    autoPlay: state.autoPlay,
    base: state.base,
    spinButtonVisible: state.UI.spinButtonVisible,
    betAmount: state.session.betAmount,
    freeRoundSpins: state.session.freeRoundSpins,
    currencySign: state.session.currencySign,
    visibleBalance: state.session.visibleBalance,
    visibleFreeRoundWin: state.session.visibleFreeRoundWin,
    dimensions: state.UI.dimensions,
    winFieldCountDuration: state.UI.winFieldCountDuration,
    popupScreen: state.UI.popupScreen,
    settingScreen: state.base.settingScreen,
    freeRoundStats: state.session.freeRoundStats,
  }),
  {
    playRequest,
    openSettingsScreen,
    setSkipFeature,
    uiButtonPressed,
    setQuickSpin,
    setPopupScreen,
    runAutoPlay,
    updateAutoplayBalance,
    setAutoPlayReStart,
  }
)
export default class GameControls extends React.Component {
  componentDidMount() {
    preventZoomOnIOS()
  }

  doUpdate = () => { this.forceUpdate() }

  shouldComponentUpdate() {
    this.timeout && cancelAnimationFrame(this.timeout)
    this.timeout = requestAnimationFrame(this.doUpdate)

    return false
  }

  onSettingsButton = () => {
    const {
      props: {
        uiButtonPressed,
        openSettingsScreen,
        setPopupScreen,
        settingScreen,
        popupScreen,
        dimensions: { desktopUI }
      }
    } = this
    if (desktopUI) {
      if (settingScreen) {
        openSettingsScreen(null)
      }
      setPopupScreen(popupScreen === POPUP_SCREENS.SETTINGS_MENU ? null : POPUP_SCREENS.SETTINGS_MENU)
      uiButtonPressed(popupScreen === POPUP_SCREENS.SETTINGS_MENU ? BUTTON_CLOSE : POPUP_SCREENS.SETTINGS_MENU)
    } else {
      openSettingsScreen(settingScreen ? null : SETTINGSCREENS.INFO)
      if (popupScreen) {
        setPopupScreen(null)
      }
      uiButtonPressed(settingScreen ? BUTTON_CLOSE : SETTINGSCREENS.INFO)
    }
  }

  onStartAutoplayButton = () => {
    const {
      props: {
        uiButtonPressed,
        runAutoPlay,
        updateAutoplayBalance,
        autoPlay: { lossLimit },
        setAutoPlayReStart,
      }
    } = this

    if (Config.autoplayForceAdvanced && !lossLimit) {
      return
    }

    updateAutoplayBalance()
    runAutoPlay()
    setAutoPlayReStart(true)
    uiButtonPressed(RUN_AUTOPLAY)
  }

  onSpinButton = () => {
    const {
      props: {
        autoPlay: { spinsLeft = 0 } = {},
        base: { playing = false, allowSpinRequests },
        playRequest,
        uiButtonPressed,
        settingScreen,
        openSettingsScreen,
      }
    } = this

    if (settingScreen) {
      openSettingsScreen(null)
    }

    if (!spinsLeft && !playing && allowSpinRequests) {
      playRequest({ ga: 'spin' })
      uiButtonPressed(PLAY)
    }
  }

  onSkipButton = () => {
    const {
      props: {
        setSkipFeature,
        uiButtonPressed,
        base: { paused, settingScreen },
        openSettingsScreen,
        dimensions: { desktopUI },
        popupScreen,
        setPopupScreen,
      }
    } = this
    if (paused) {
      if (settingScreen) {
        openSettingsScreen(null)
      }
      if (!desktopUI && popupScreen) {
        setPopupScreen(null)
      }
    } else {
      setSkipFeature(true)
    }
    uiButtonPressed(PLAY)
  }

  onQuickspinButton = () => {
    const {
      props: { base: { settings } = {}, setQuickSpin, uiButtonPressed }
    } = this
    const { quickSpin = false } = settings

    setQuickSpin(!quickSpin)
    uiButtonPressed(SET_QUICKSPIN)
  }

  onQuickBetsButton = () => {
    const {
      props: { popupScreen, setPopupScreen, uiButtonPressed }
    } = this
    setPopupScreen(popupScreen === POPUP_SCREENS.BET ? null : POPUP_SCREENS.BET)
    uiButtonPressed(popupScreen === POPUP_SCREENS.BET ? BUTTON_CLOSE : POPUP_SCREENS.BET)
  }

  renderControls = () => {
    const {
      props: {
        dimensions,
        popupScreen,
        svgIcons,
      },
      onSettingsButton,
    } = this

    const settingsButtonProps = {
      onClick: onSettingsButton,
      svgIcons,
      selected: popupScreen === POPUP_SCREENS.SETTINGS_MENU,
    }

    const showSettingsButton = dimensions.width > 900

    const quickspinEnabled = Config.FEATURE_CONFIG.QUICKSPIN

    return showSettingsButton &&
      <div className={`controls${quickspinEnabled ? '' : ' no-quickspin'}`}>
        <SettingsButton {...settingsButtonProps} />
      </div>
  }

  getAutoPlayVisibility = () => {
    const {
      base: { displayFreeRound } = {}, freeRoundStats,
    } = this.props
    return !Config.autoplayDisable && (!displayFreeRound || (freeRoundStats && freeRoundStats.autoplay))
  }

  renderSpinArea = () => {
    const {
      props: {
        autoPlay: { spinsLeft = 0, autoPlaying } = {},
        base: {
          playing = false,
          settings,
          skipfeature,
          paused,
          delayingSpin,
          allowSpinRequests,
          settingScreen,
          externalPause,
        } = {},
        spinButtonVisible,
        dimensions,
        popupScreen,
        svgIcons,
      },
      onStartAutoplayButton,
      onSpinButton,
      onSkipButton,
      onQuickspinButton,
      onQuickBetsButton,
      onSettingsButton,
    } = this
    const { quickSpin } = settings || {}
    const { spinAreaScale, desktopUI } = dimensions

    const settingsProps = {
      onClick: onSettingsButton,
      svgIcons,
      selected: !!settingScreen,
    }

    const spinEnabled = allowSpinRequests && !playing && !spinsLeft && !externalPause
    const quickspinEnabled = Config.FEATURE_CONFIG.QUICKSPIN
    const quickBetsEnabled = allowSpinRequests && !playing && !autoPlaying

    const spinAreaProps = {
      className: 'spin-area',
      style: { touchAction: 'none', height: dimensions.height }
    }

    const quickSpinProps = {
      enabled: spinEnabled,
      active: quickSpin,
      onClick: onQuickspinButton,
      svgIcons,
    }

    const startAutoplayButtonProps = {
      available: spinButtonVisible,
      enabled: spinsLeft && !autoPlaying,
      onClick: onStartAutoplayButton,
      type: 'start-autoplay',
    }

    const spinButtonProps = {
      available: spinButtonVisible,
      enabled: spinEnabled,
      onClick: spinEnabled ? onSpinButton : undefined,
      type: 'spin',
    }

    const skipButtonProps = {
      available: spinButtonVisible,
      enabled: !paused && !skipfeature && !Config.disableSkipFeature && !delayingSpin,
      onClick: !skipfeature && !delayingSpin ? onSkipButton : undefined,
      type: 'skip',
    }

    const quickBetProps = {
      enabled: quickBetsEnabled,
      betPopupVisible: popupScreen === POPUP_SCREENS.BET,
      onClick: onQuickBetsButton,
      svgIcons,
    }

    let buttonProps
    if (spinsLeft && !autoPlaying && allowSpinRequests) {
      buttonProps = startAutoplayButtonProps
    } else {
      buttonProps = spinEnabled ? spinButtonProps : skipButtonProps
    }

    const currentButton =
      <SpinButton
        {...buttonProps}
        scale={spinAreaScale}
        height={dimensions.height}
        width={dimensions.width}
        delayingSpin={delayingSpin}
        paused={paused}
        svgIcons={svgIcons}
      />

    const showAutoPlay = this.getAutoPlayVisibility()

    const autoPlayProps = {
      scale: spinAreaScale,
      dimensions,
      svgIcons,
    }

    const showSettingsButton = dimensions.width <= 900

    return (
      <div {...spinAreaProps}>
        {showSettingsButton && <SettingsButton {...settingsProps} scale={spinAreaScale} />}
        {quickspinEnabled && <QuickspinButton {...quickSpinProps} scale={spinAreaScale} />}
        {currentButton}
        {showAutoPlay && <Autoplay {...autoPlayProps} scale={spinAreaScale} />}
        {!desktopUI && <QuickBetButton {...quickBetProps} scale={spinAreaScale} />}
      </div>
    )
  }

  render() {
    const {
      props: {
        base: { skipfeature, displayFreeRound, win, dropWinCount, isTournament, sideGames } = {},
        freeRoundSpins,
        currencySign,
        visibleBalance,
        visibleFreeRoundWin,
        dimensions,
        winFieldCountDuration,
        svgIcons,
        betAmount,
        formatStyle,
      },
      renderControls,
      renderSpinArea,
    } = this

    const { desktopUI, height, gamecontrolScale, width, portrait } = dimensions
    const controlHeight = desktopUI
      ? { top: portrait ? 0 : Math.min(70, height * 0.1) / 2 * (gamecontrolScale - 1) }
      : { height }
    const controlsProps = {
      className: 'gameControls',
      onTouchMove: stopPropagation,
      style: {
        touchAction: 'none',
        transform: `scale(${gamecontrolScale})`,
        width,
        ...controlHeight
      }
    }

    const autoPlayVisible = this.getAutoPlayVisibility()

    const freeRoundsActive = displayFreeRound && !isTournament
    const tournamentActive = displayFreeRound && isTournament
    const winAreaProps = {
      name: freeRoundsActive ? 'runningTotal' : 'win',
      currencySign,
      value: freeRoundsActive ? visibleFreeRoundWin : win,
      dropCount: dropWinCount,
      prefix: freeRoundsActive ? 'freerounds' : 'gameControl',
      showCurrency: !tournamentActive,
      duration: winFieldCountDuration,
      formatStyle,
      autoPlayVisible,
    }

    const fieldName = tournamentActive ? 'tournamentScore' : 'balance'
    const balanceAreaProps = {
      key: fieldName,
      name: fieldName,
      currencySign,
      value: tournamentActive ? visibleFreeRoundWin : visibleBalance,
      prefix: tournamentActive ? 'tournament' : 'gameControl',
      showCurrency: !tournamentActive,
      skipfeature,
      duration: 1500,
      formatStyle,
      autoPlayVisible,
    }

    const betAreaProps = {
      value: getBet(sideGames, betAmount),
      dimensions,
      svgIcons,
      formatStyle,
    }

    return (
      <div id="gameControls" {...controlsProps}>
        <div className="bg-field-smartphone" />
        {renderControls()}
        {displayFreeRound ? (
          <SimpleArea {...{
            name: isTournament ? 'tournamentspins' : 'freespins',
            value: freeRoundSpins,
            prefix: isTournament ? 'tournament' : 'freerounds',
            dimensions,
          }} />
        ) : (
          <BetArea {...betAreaProps} />
        )}
        {renderSpinArea()}
        <InfoArea {...winAreaProps} />
        <InfoArea {...balanceAreaProps} />
      </div>
    )
  }
}